<template>
  <sidebar-layout>
    <template #default>
      <router-view :key="$route.path" />
    </template>

    <template #navigation>
      <sidebar-navigation :navigation="navigation" :links="links" />
    </template>

    <template #menu>
      <dropdown-user :user="user" :items="dropdownNavigation" @clicked="onClick" />
    </template>
  </sidebar-layout>
</template>

<script setup>
import { computed } from 'vue';
import { getUser } from '../composables/useAuth';
import SidebarLayout from '../templates/SidebarLayout.vue';
import SidebarNavigation from '../components/SidebarNavigation.vue';
import DropdownUser from '../components/DropdownUser.vue';
import { useRouter } from 'vue-router';

import {
  FolderIcon,
  HomeIcon,
  UserCircleIcon,
  CogIcon,
  PowerIcon,
  UsersIcon,
  CpuChipIcon,
  BookOpenIcon,
  MegaphoneIcon,
  CircleStackIcon,
  ArrowLeftEndOnRectangleIcon,
  TagIcon,
  WrenchScrewdriverIcon,
  WrenchIcon,
  AcademicCapIcon,
  ArrowPathRoundedSquareIcon,
  BoltIcon,
  InboxArrowDownIcon,
  CreditCardIcon
} from '@heroicons/vue/24/outline';

const router = useRouter();
const user = getUser();

const navigation = computed(() => {
  if (user.value.tier === 'support') {
    return [
      { name: 'Users', to: '/users', icon: UsersIcon },
      { name: 'Programs', to: '/programs', icon: FolderIcon },
      { name: 'Sessions', to: '/sessions', icon: CpuChipIcon }
    ];
  }

  if (user.value.tier === 'session-analytics') {
    return [
      { name: 'Dashboard', to: '/dashboard', icon: HomeIcon },
      { name: 'Programs', to: '/programs', icon: FolderIcon },
      { name: 'Sessions', to: '/sessions', icon: CpuChipIcon }
    ];
  }

  const items = [
    { name: 'Dashboard', to: '/dashboard', icon: HomeIcon },
    { name: 'Programs', to: '/programs', icon: FolderIcon },
    { name: 'Plugins', to: '/plugins', icon: WrenchScrewdriverIcon },
    { name: 'Banners', to: '/banners', icon: MegaphoneIcon },
    { name: 'Sessions', to: '/sessions', icon: CpuChipIcon },
    { name: 'Onboarding Slides', to: '/onboarding-slides', icon: AcademicCapIcon }
  ];

  if (user.value.tier === 'admin') {
    items.push({ name: 'Users', to: '/users', icon: UsersIcon });
    items.push({ name: 'Stripe Webhook Events', to: '/stripe-webhook-events', icon: BoltIcon });
    items.push({ name: 'Stripe Outbox Events', to: '/stripe-outbox-events', icon: InboxArrowDownIcon });
    items.push({ name: 'Action Log', to: '/action-logs', icon: BookOpenIcon });
    items.push({ name: 'Data Centers', to: '/data-centers', icon: CircleStackIcon });
    items.push({ name: 'Login Attempts', to: '/login-attempts', icon: ArrowLeftEndOnRectangleIcon });
    items.push({ name: 'Maintenance', to: '/maintenance', icon: WrenchIcon });
    items.push({ name: 'Versions', to: '/versions', icon: TagIcon });
    items.push({ name: 'Data Sync', to: '/data-sync', icon: ArrowPathRoundedSquareIcon });
    items.push({ name: 'Payment Event Logs', to: '/payment-event-logs', icon: CreditCardIcon });
  }
  return items;
});

const links = [
  { id: 1, name: 'Swagger admin API', href: '/docs/', initial: 'S' },
  { id: 2, name: 'Heroicons', href: 'https://heroicons.com/', initial: 'H' },
  { id: 3, name: 'Tailwind', href: 'https://tailwindcss.com/', initial: 'T' }
];

const dropdownNavigation = [
  [
    { name: 'Your Profile', icon: UserCircleIcon },
    { name: 'Settings', icon: CogIcon }
  ],
  [
    { name: 'Sign out', icon: PowerIcon, to: '/logout' }
  ]
];

function onClick(item) {
  if (item.to) {
    router.push(item.to);
    return;
  }

  console.log(item);
}
</script>
